<div class="container-fluid batch-page">
  <nav class="navbar sticky-top batch-page__nav">
    <div class="d-grid gap-2 d-flex navbar-brand">
      <button
        (click)="location.back()"
        type="button"
        class="btn btn-primary backBtn"
        aria-label="Back"
        ngbTooltip="Back"
        placement="bottom"
      >
        <fa-icon [icon]="faAngleLeft"></fa-icon>
      </button>
      <h2 class="mobileHeading">Automation</h2>
    </div>
  </nav>
    <div class="row mt-3">
    <div class="col-12 mb-3">
      <ul ngbNav #nav="ngbNav" class="nav-tabs">
        <li ngbNavItem="AUTOMATION">
          <a ngbNavLink>Batch Cloning</a>
          <ng-template ngbNavContent>
            <bulk-batch-cloning-table
              [rows]="jobRows()"
              [totalItems]="jobCount()"
              [fromDate]="jobsFromDate()"
              [toDate]="jobsToDate()"
              (fromDateChange)="jobsFromDate.set($event)"
              (toDateChange)="jobsToDate.set($event)"
              (applyFilters)="applyJobsFilters()"
              (clearFilters)="clearJobsFilters()"
              (viewDetails)="viewJobDetails($event)"
            ></bulk-batch-cloning-table>
          </ng-template>
        </li>
        <li ngbNavItem="SCHEDULE-CALENDAR">
          <a ngbNavLink>Schedule Calendar</a>
          <ng-template ngbNavContent>
            <app-schedule-calendar-jobs
              [data]="scheduleCalendarRows()"
              (dateChange)="onScheduleCalendarDateChange($event)"
              (reschedule)="onScheduleReschedule($event)"
              (cancel)="onScheduleCancel($event)"
            ></app-schedule-calendar-jobs>
          </ng-template>
        </li>
        <li ngbNavItem="SCHEDULE-TABLE">
          <a ngbNavLink>Schedule Table</a>
          <ng-template ngbNavContent>
            <app-schedule-table
              [data]="scheduleRows()"
              [totalCount]="scheduleCount()"
              [page]="schedulePage()"
              [limit]="scheduleLimit()"
              [searchValue]="scheduleSearch()"
              jobLinkBase="/portal/batch-cloning/jobs"

              (pageChange)="onSchedulePageChange($event)"
              (limitChange)="onScheduleLimitChange($event)"
              (searchChange)="onScheduleSearch($event)"

              (retry)="onRetrySchedule($event)"
              (cancel)="onCancelSchedule($event)"
              (reschedule)="onRescheduleSchedule($event)"
              (viewJobSchedule)="viewJobSchedule($event)"
            ></app-schedule-table>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-1"></div>
</div>